
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IRowTextWithImage } from '~/types/sanity-objects';
import ImageTextWithRow from '~/components/UIComponents/ImageWithTextRow.vue';
import SanityBlockContent from './SanityBlockContent.vue';

@Component({
  components: {
    ImageTextWithRow,
    SanityBlockContent,
  },
})
export default class SanityRowTextWithImage extends Vue {
  @Prop({ type: String, default: 'primary' })
  readonly bgColor!: 'primary' | 'secondary' | 'tertiary';
  @Prop(Object)
  readonly data!: IRowTextWithImage;
  @Prop({ type: Number, default: 600 })
  readonly imageWidth!: number;
  @Prop(Number)
  readonly imageHeight!: number;
  @Prop([String, Object])
  readonly bodyClass!: Record<string, boolean> | string;
  @Prop([String, Object])
  readonly sectionTitleClass!: Record<string, boolean> | string;
  @Prop([String, Object])
  readonly titleClass!: Record<string, boolean> | string;

  get bodyBlocks() {
    return this.data?.body;
  }

  get imageUrl() {
    return this.data?.image?.asset._ref
      ? this.$sanityImage
          .urlFor(this.data.image)
          .width(this.imageWidth)
          .height(this.imageHeight || this.imageWidth)
          .fit('crop')
          .url()
      : undefined;
  }

  get isColumnLayoutReversed() {
    return !!this.data?.displayOptions?.isColumnLayoutReversed;
  }

  get isHeroImage() {
    return !!this.data?.displayOptions?.isHeroImage;
  }

  get isRowLayoutReversed() {
    return !!this.data?.displayOptions?.isRowLayoutReversed;
  }

  get title() {
    return this.data?.title;
  }

  get titleId() {
    return this.title ? this.$id('section-title') : undefined;
  }

  get blockTitleTag() {
    return this.title ? 'h3' : 'h2';
  }
}
